import AppData from './AppData';

let lastTableSessionId = -2
class TableSessionHelper {
    static hasSession = () => {
        return AppData.data && AppData.data.state && AppData.data.state.table_session != null
    }
    static hasSessionAndPin = (skipLog) => {
        return AppData.data && AppData.data.state && AppData.data.state.table_session != null && AppData.data.state.table_session.pin != null
    }
    static isAllowMultiTableSession = () => {
        return AppData.data && AppData.data.isMerchantHasFeature('multi_table_session_per_table')
    }
    static isNoPinSingleSessionMode = () => {
        return AppData.data && AppData.data.isMerchantHasFeature('no_pin_single_session_mode')
    }
    static isNeedToTriggerJoinTable = () => {
        return !TableSessionHelper.isAllowMultiTableSession() && !TableSessionHelper.isNoPinSingleSessionMode() && TableSessionHelper.hasSessionAndPin(true) && AppData.data.state.current_session == null
    }
    static getNewTempTableSession = (tableId) => {
        // Simple rule is that temporary sessions has negative ID,
        // -2, -3, -4, ...
        // When we pass order that has negative table_session_id to API,
        // API shall create a new table session to store the orders
        return {
            id: lastTableSessionId--,
            table_id: tableId,
        }
    }
    /**
     * For the given table, find all active table sessions
     */
    static getSessionsForTable = (table) => {
        if (!AppData.data || !AppData.data.state.sessions || !Array.isArray(AppData.data.state.sessions)) {
            return []
        }
        let tableSessions = AppData.data && AppData.data.state.sessions.filter(elem => { return elem.table_id == table.id; })
        return tableSessions;
    }

    static find = (id) => {
        if (!AppData.data || !AppData.data.state.sessions || !Array.isArray(AppData.data.state.sessions)) {
            return null
        }
        let tableSession = AppData.data && AppData.data.state.sessions.find(elem => { return elem.id == id })
        return tableSession
    }

    /**
     * For the given table, find all active table sessions, where the table
     * sessions contain at least one or more 'active' order
     *
     * @param {Table} table - Table object
     * @return Array
     */
    static getSessionsForTableWithActiveOrders = (table) => {
        const tableSessionWithActiveOrders = AppData.data.state.tableSessionWithActiveOrders
        if (tableSessionWithActiveOrders) {
            return tableSessionWithActiveOrders[table.id] || []
        }
    }

    static getFilter = () => {
        // We might have other custom logic to filter the table sessions.
        // Case A - For pickup orders, only list those of matching customer id
        return AppData.data.state.tableSessionFilter
    }

    static setOrderReady = ({tableSessionIds, queueNumberPageItemId, isReady, isDelivery = false, isDineIn = false}) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchants/orders/set_ready`,
                type    : 'post',
                data    : {
                    queue_number_page_item_id: queueNumberPageItemId,
                    table_session_ids: tableSessionIds,
                    is_ready: isReady ? 1 : 0,
                    is_delivery: isDelivery ? 1 : 0,
                    is_dine_in: isDineIn ? 1 : 0,
                },
                success : (res) => {
                    resolve(res)
                }
            })
            .fail(() => {
                reject()
            })
        })
    }

    static getOrders = (tableSessionId, orderStatus) => {
        return AppData.data.state.orders.filter(order => {
            return order.table_session_id == tableSessionId && (!orderStatus || order.order_status == orderStatus)
        })
    }
}
export default TableSessionHelper;